import { useParams } from 'react-router-dom';
import { EscalateDialogModule } from '../../../modules/dialogs/escalate';

export const EscalateClaimPage = () => {
  const { invoiceId } = useParams();

  if (!invoiceId) {
    throw new Error('Invoice ID not provided.');
  }
  return <EscalateDialogModule invoiceId={invoiceId} transNs={'page-claim-detail'} keyPrefix={'escalation'} />;
};
